export interface VehicleCategoryListItem {
  uid: string;
  code: string;
  name: string;
}

export interface LocationListItem {
  uid: string;
  name: string;
  referenceCode: string;
  countryUid: string;
  countryName: string;
  countryCode: string;
}

export interface CountryListItem {
  uid: string;
  countryName: string;
  code: string;
}

export interface CurrencyListItem {
  uid: string;
  code: string;
  name: string;
}

export interface BrokerListItem {
  uid: string;
  name: string;
  code: number;
}

export enum DriverDocumentType {
  Other = 0,
  IdentityCard = 1,
  Passport = 2
}

export enum ValueItemType {
  Price = 0,
  Extra = 1
}

export enum UserRoles {
  AddCarAdmin = 0,
  FranchiseeAdmin = 1,
  AddCarUser = 2,
  FranchiseeUser = 3
}
